import React from 'react';
import {
  Popover as AriaPopover,
  PopoverProps as AriaPopoverProps,
  OverlayArrow,
  PopoverContext,
  useSlottedContext,
} from 'react-aria-components';
import useFullscreenContainer from '../shared/useFullscreenContainer';
import { cx } from '../util';

export interface ClarionBasePopoverProps extends Omit<AriaPopoverProps, 'children'> {
  showArrow?: boolean;
  children: React.ReactNode;
}

export function ClarionBasePopover({
  children,
  showArrow,
  className,
  ...props
}: ClarionBasePopoverProps) {
  const fullscreenElement = useFullscreenContainer();
  let popoverContext = useSlottedContext(PopoverContext)!;
  let isSubmenu = popoverContext?.trigger === 'SubmenuTrigger';
  let offset = showArrow ? 12 : 8;
  offset = isSubmenu ? offset - 6 : offset;
  return (
    <AriaPopover
      offset={offset}
      {...props}
      className={cx(
        'bg-white dark:bg-neutral-800 shadow-2xl rounded-lg border border-black/10 dark:border-white/15 text-gray-700 dark:text-neutral-300',
        className,
      )}
      UNSTABLE_portalContainer={fullscreenElement}
    >
      {children}
      {showArrow && (
        <OverlayArrow className="group">
          <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            className="block fill-white dark:fill-neutral-800 stroke-1 stroke-black/10 dark:stroke-white/15 group-data-[placement='bottom']:rotate-180 group-data-[placement='left']:-rotate-90 group-data-[placement='right']:rotate-90"
          >
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
      )}
    </AriaPopover>
  );
}
